/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateTimesheetEntryDataTimesheetBreaksInner } from './UpdateTimesheetEntryDataTimesheetBreaksInner';
import {
    UpdateTimesheetEntryDataTimesheetBreaksInnerFromJSON,
    UpdateTimesheetEntryDataTimesheetBreaksInnerFromJSONTyped,
    UpdateTimesheetEntryDataTimesheetBreaksInnerToJSON,
    UpdateTimesheetEntryDataTimesheetBreaksInnerToJSONTyped,
} from './UpdateTimesheetEntryDataTimesheetBreaksInner';

/**
 * 
 * @export
 * @interface UpdateTimesheetEntryData
 */
export interface UpdateTimesheetEntryData {
    /**
     * 
     * @type {number}
     * @memberof UpdateTimesheetEntryData
     */
    employeeId?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTimesheetEntryData
     */
    jobRoleId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTimesheetEntryData
     */
    locationId?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTimesheetEntryData
     */
    shiftId?: number;
    /**
     * 
     * @type {Date}
     * @memberof UpdateTimesheetEntryData
     */
    startedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateTimesheetEntryData
     */
    endedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateTimesheetEntryData
     */
    confirmedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof UpdateTimesheetEntryData
     */
    confirmedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTimesheetEntryData
     */
    notes?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateTimesheetEntryData
     */
    tags?: Array<number> | null;
    /**
     * 
     * @type {Array<UpdateTimesheetEntryDataTimesheetBreaksInner>}
     * @memberof UpdateTimesheetEntryData
     */
    timesheetBreaks?: Array<UpdateTimesheetEntryDataTimesheetBreaksInner>;
}

/**
 * Check if a given object implements the UpdateTimesheetEntryData interface.
 */
export function instanceOfUpdateTimesheetEntryData(value: object): value is UpdateTimesheetEntryData {
    return true;
}

export function UpdateTimesheetEntryDataFromJSON(json: any): UpdateTimesheetEntryData {
    return UpdateTimesheetEntryDataFromJSONTyped(json, false);
}

export function UpdateTimesheetEntryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTimesheetEntryData {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'jobRoleId': json['jobRoleId'] == null ? undefined : json['jobRoleId'],
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'shiftId': json['shiftId'] == null ? undefined : json['shiftId'],
        'startedAt': json['startedAt'] == null ? undefined : (new Date(json['startedAt'])),
        'endedAt': json['endedAt'] == null ? undefined : (new Date(json['endedAt'])),
        'confirmedAt': json['confirmedAt'] == null ? undefined : (new Date(json['confirmedAt'])),
        'confirmedBy': json['confirmedBy'] == null ? undefined : json['confirmedBy'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'timesheetBreaks': json['timesheetBreaks'] == null ? undefined : ((json['timesheetBreaks'] as Array<any>).map(UpdateTimesheetEntryDataTimesheetBreaksInnerFromJSON)),
    };
}

  export function UpdateTimesheetEntryDataToJSON(json: any): UpdateTimesheetEntryData {
      return UpdateTimesheetEntryDataToJSONTyped(json, false);
  }

  export function UpdateTimesheetEntryDataToJSONTyped(value?: UpdateTimesheetEntryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
        'jobRoleId': value['jobRoleId'],
        'locationId': value['locationId'],
        'shiftId': value['shiftId'],
        'startedAt': value['startedAt'] == null ? undefined : ((value['startedAt']).toISOString()),
        'endedAt': value['endedAt'] == null ? undefined : ((value['endedAt']).toISOString()),
        'confirmedAt': value['confirmedAt'] == null ? undefined : ((value['confirmedAt']).toISOString()),
        'confirmedBy': value['confirmedBy'],
        'notes': value['notes'],
        'tags': value['tags'],
        'timesheetBreaks': value['timesheetBreaks'] == null ? undefined : ((value['timesheetBreaks'] as Array<any>).map(UpdateTimesheetEntryDataTimesheetBreaksInnerToJSON)),
    };
}

